import { Button, Col, Divider, Row } from 'antd';
import { DownOutlined, SoundFilled } from '@ant-design/icons';
import styled, { css } from 'styled-components';
import { getColor, getSize, media } from '@lib/common';
export var SummaryCard = styled.div.withConfig({
  displayName: "submission-section-summary-v3styles__SummaryCard",
  componentId: "sc-jp3c7m-0"
})(["box-sizing:border-box;width:100%;max-width:100%;overflow:hidden;background:", ";border:1px solid ", ";border-radius:", ";box-shadow:0 2px 6px rgba(15,23,42,0.12);"], getColor('fillBgWhite'), getColor('shapeBorder'), getSize('radius'));
export var OverviewHeader = styled.div.withConfig({
  displayName: "submission-section-summary-v3styles__OverviewHeader",
  componentId: "sc-jp3c7m-1"
})(["display:flex;align-items:center;justify-content:space-between;gap:", ";padding:", ";border-bottom:1px solid ", ";color:", ";font-size:", ";font-weight:700;", "{display:none;}"], getSize('gap16'), getSize('padding16'), getColor('shapeBorder'), getColor('contentHeading'), getSize('typo14'), media.mobile);
export var OverviewProgress = styled.span.withConfig({
  displayName: "submission-section-summary-v3styles__OverviewProgress",
  componentId: "sc-jp3c7m-2"
})(["flex-shrink:0;color:", ";font-size:", ";font-weight:600;"], getColor('textIntSub'), getSize('typo14'));
export var SectionPanel = styled.div.withConfig({
  displayName: "submission-section-summary-v3styles__SectionPanel",
  componentId: "sc-jp3c7m-3"
})(["padding:", ";background:", ";"], getSize('padding16'), getColor('fillBgWhite'));
export var SectionTitle = styled.div.withConfig({
  displayName: "submission-section-summary-v3styles__SectionTitle",
  componentId: "sc-jp3c7m-4"
})(["display:flex;align-items:flex-start;justify-content:space-between;gap:", ";", ""], getSize('gap16'), function (_ref) {
  var $isExpanded = _ref.$isExpanded,
      $isCollapsible = _ref.$isCollapsible;
  return css(["margin-bottom:", ";cursor:", ";"], $isExpanded ? getSize('padding16') : 0, $isCollapsible ? 'pointer' : 'default');
});
export var SectionHeader = styled.div.withConfig({
  displayName: "submission-section-summary-v3styles__SectionHeader",
  componentId: "sc-jp3c7m-5"
})(["display:flex;flex:1;min-width:0;align-items:center;gap:", ";color:", ";font-size:", ";"], getSize('gap12'), getColor('contentHeading'), getSize('typo14'));
export var SectionTitleText = styled.strong.withConfig({
  displayName: "submission-section-summary-v3styles__SectionTitleText",
  componentId: "sc-jp3c7m-6"
})(["display:-webkit-box;flex:1;min-width:0;overflow:hidden;line-height:1.35;white-space:normal;-webkit-box-orient:vertical;-webkit-line-clamp:2;"]);
export var SectionChevron = styled(DownOutlined).withConfig({
  displayName: "submission-section-summary-v3styles__SectionChevron",
  componentId: "sc-jp3c7m-7"
})(["flex-shrink:0;color:", ";font-size:", ";", ""], getColor('shapeEmphasized'), getSize('typo12'), function (_ref2) {
  var $isExpanded = _ref2.$isExpanded;
  return css(["transform:rotate(", "deg);transition:transform 0.2s ease;"], $isExpanded ? 0 : -90);
});
export var PlayingAudioIcon = styled(SoundFilled).withConfig({
  displayName: "submission-section-summary-v3styles__PlayingAudioIcon",
  componentId: "sc-jp3c7m-8"
})(["flex-shrink:0;margin-left:", ";font-size:18px;"], getSize('padding20'));
export var AnswerProgress = styled.p.withConfig({
  displayName: "submission-section-summary-v3styles__AnswerProgress",
  componentId: "sc-jp3c7m-9"
})(["flex-shrink:0;margin-bottom:0;color:", ";font-size:", ";font-weight:500;white-space:nowrap;"], getColor('textIntSub'), getSize('typo14'));
export var QuestionGrid = styled(Row).withConfig({
  displayName: "submission-section-summary-v3styles__QuestionGrid",
  componentId: "sc-jp3c7m-10"
})(["display:flex;flex-wrap:wrap;width:100%;gap:", ";margin:0 !important;"], getSize('gap8'));
export var QuestionItemColumn = styled(Col).withConfig({
  displayName: "submission-section-summary-v3styles__QuestionItemColumn",
  componentId: "sc-jp3c7m-11"
})([""]);
export var QuestionItem = styled(Button).withConfig({
  displayName: "submission-section-summary-v3styles__QuestionItem",
  componentId: "sc-jp3c7m-12"
})(["display:flex;align-items:center;justify-content:center;width:44px;height:40px;margin:0;padding:0;border-radius:", ";box-shadow:none;font-size:", ";font-weight:600;", ""], getSize('padding8'), getSize('typo14'), function (_ref3) {
  var $isSelected = _ref3.$isSelected,
      $isAnswered = _ref3.$isAnswered;
  return css(["border-color:", ";color:", ";background-color:", ";&:hover{border-color:", ";color:", ";background-color:", ";}&:focus,&:active{border-color:", ";color:", ";background-color:", ";}"], $isSelected || $isAnswered ? getColor('shapeHighlighted') : getColor('shapeBorder'), $isSelected || $isAnswered ? getColor('textIntHighlighted') : getColor('textIntSub'), $isSelected ? getColor('fillBgWhite') : $isAnswered ? getColor('fillIntHighlighted') : getColor('fillBgWhite'), getColor('shapeHighlighted'), getColor('textIntHighlighted'), $isSelected ? getColor('fillBgWhite') : $isAnswered ? getColor('fillIntHighlighted') : getColor('fillIconBgDefault'), $isSelected || $isAnswered ? getColor('shapeHighlighted') : getColor('shapeBorder'), $isSelected || $isAnswered ? getColor('textIntHighlighted') : getColor('textIntSub'), $isSelected ? getColor('fillBgWhite') : $isAnswered ? getColor('fillIntHighlighted') : getColor('fillBgWhite'));
});
export var SectionDivider = styled(Divider).withConfig({
  displayName: "submission-section-summary-v3styles__SectionDivider",
  componentId: "sc-jp3c7m-13"
})(["margin:0;border-color:", ";"], getColor('shapeBorder'));